import styled from "styled-components";

export const BrandIcon = styled.img`
	max-width: 240px;
	height: auto !important;
`;
